import { RawDetection, Snapshot, TrackID } from "@/shared/types";
import { ExtendedBin } from "@/virtual-store/planogram/types";
import { computed, observable } from "@legendapp/state";
import { InstancedMesh } from "three";
import tunnel from "tunnel-rat";

export const calibrationTunnel = tunnel();
export const loadingProgressTunnel = tunnel();

export const visibleTracksSnapshots$ = observable<Map<TrackID, Snapshot>>(
  new Map()
);
export const visibleTrackIds$ = computed(() =>
  visibleTracksSnapshots$.get().keys()
);

export const selectedTrack$ = observable<TrackID | null>(null);
export const cameraIds$ = observable<string[]>([]);
export const camerasMesh$ = observable<InstancedMesh>();
export const selectedTrackPosition$ = observable<[number, number, number]>();
export const hiddenTracks$ = observable<Set<TrackID>>(new Set<TrackID>());
export const importedDetections$ = observable<RawDetection[]>();
export const detectionToTrackMap$ = observable<Record<string, TrackID>>({});
export const selectedBin$ = observable<ExtendedBin | null>(null);

export const toggleTrackVisibility = (trackId: string) => {
  if (!hiddenTracks$.has(trackId)) {
    hiddenTracks$.add(trackId);
  } else {
    hiddenTracks$.delete(trackId);
  }
};

export const resetGlobalObservables = () => {
  visibleTracksSnapshots$.set(new Map());
  selectedTrack$.set(null);
  selectedTrackPosition$.set(null);
};
